import type { AppSettings, Resource } from '@/types';

export function isPlannerGroupMode(settings: AppSettings): boolean {
  return settings.groupingMethod === 'scheduler-group';
}

export function groupingColLabel(plannerGroupMode: boolean): string {
  return plannerGroupMode ? 'Planner Group' : 'Department';
}

/** Value of a resource's grouping dimension, honouring the global grouping method. */
export function groupingLabelFor(r: Resource, groupingMethod: AppSettings['groupingMethod']): string {
  return groupingMethod === 'department'
    ? (r.department ?? '—')
    : (r.schedulerGroup ?? r.department ?? '—');
}
